// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_UpdateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /fechamentos/update/{id}
 *
 * Validates monthly accounting period update requests.
 * All fields are optional for partial updates.
 */
import { registerContract } from './validate'

export interface Fechamentos_UpdateInput {
meta_faturamento?: number
meta_clientes?: number
meta_itens?: number
}

registerContract('Fechamentos_UpdateInput', {
  meta_faturamento: { type: 'number',  required: false },
  meta_clientes:    { type: 'number',  required: false },
  meta_itens:       { type: 'number',  required: false },
})
